import { useLocation } from "react-router-dom";

import {
  useRedirectOnCondition,
  useSimpleNavigationCallback
} from "seneca-common/utils/hooks/routing";

import useAppVariant from "features/common/hooks/useAppVariant";
import { makeInternalRedirectState } from "features/common/routing/InternalRedirectOnlyRoute";
import useSignUpJourneyStateOnMount from "features/sign-up/global-sign-up-modal/hooks/useSignUpJourneyStateOnMount";
import SignUpUserDetailsForm from "features/sign-up/sign-up-form/components/SignUpFormUserDetails";

type Props = {
  pageNumber: number;
  totalNumberOfPages: number;
  linkToNextPage: string | null | undefined;
  accountType?: string;
  search: string;
};

export default function SignUpUserDetails({
  linkToNextPage,
  accountType,
  search,
  ...other
}: Props) {
  const location = useLocation();

  const { redirectAuthenticatedUserTo } = useSignUpJourneyStateOnMount();
  const skipUserDetails = useSkipUserDetaisByVariant();

  useRedirectOnCondition(skipUserDetails, redirectAuthenticatedUserTo);

  const navigateTo = useSimpleNavigationCallback(
    makeInternalRedirectState({
      pathname: linkToNextPage as any,
      state: location.state,
      search
    } as any) as any
  );

  const onSignUpUserDetailsSuccess = async () => {
    navigateTo();
  };

  return (
    // @ts-ignore
    <SignUpUserDetailsForm
      {...other}
      accountType={accountType}
      onExtraSignUpDetailsSuccess={onSignUpUserDetailsSuccess}
    />
  );
}

function useSkipUserDetaisByVariant() {
  const appVariant = useAppVariant();

  const valuesByVariant = {
    seneca: false,
    senecaPrimary: false,
    plurall: false,
    goStudentLearning: true
  };

  return valuesByVariant[appVariant];
}
